// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mls-form-container {\n  margin-bottom: 1rem;\n}\n@media (min-width: 900px) {\n  .mls-form-container {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 1rem;\n    margin-bottom: 0;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
